import axios from 'axios'
import endpoints from '../../endpoints'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function uploadDrivers(file: any) {
  try {
    const response = await axios.post(API_URL + endpoints.driver.bulkUpload, file)
    return response.data
  } catch (error) {
    console.error('Error sending message:', error)
    throw error
  }
}
